import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/paymentMethods';
const DARK_THEME_PATH = 'icons/darkTheme/paymentMethods';

const icon = (path: string, fileName: string) => getStaticFile({ path, fileName });

export const AmericanExpress = {
  alt: 'Pague com American Express',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-american-express.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-american-express.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-american-express.svg'),
    height: 40,
    width: 40,
  },
};

export const Bndes = {
  alt: 'Pague com BNDES',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-bndes.svg'),
    height: 0,
    width: 0,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-bndes.svg'),
    height: 0,
    width: 0,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-bndes.svg'),
    height: 0,
    width: 0,
  },
};

export const CarneDigital = {
  alt: 'Pague com Carnê Digital',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-carne-digital.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-carne-digital.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-carne-digital.svg'),
    height: 40,
    width: 40,
  },
};

export const Boleto = {
  alt: 'Pague com Boleto',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-boleto.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-boleto.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-boleto.svg'),
    height: 40,
    width: 40,
  },
};

export const DinnersClub = {
  alt: 'Pague com DinnersClub',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-dinners-club.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-dinners-club.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-dinners-club.svg'),
    height: 40,
    width: 40,
  },
};

export const Elo = {
  alt: 'Pague com Elo',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-elo.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-elo.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-elo.svg'),
    height: 40,
    width: 40,
  },
};

export const HiperCard = {
  alt: 'Pague com HiperCard',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-hiper-card.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-hiper-card.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-hiper-card.svg'),
    height: 40,
    width: 40,
  },
};

export const MasterCard = {
  alt: 'Pague com MasterCard',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-master-card.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-master-card.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-master-card.svg'),
    height: 40,
    width: 40,
  },
};

export const PixGray = {
  alt: 'Pague com Pix',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-pix-gray.svg'),
    height: 0,
    width: 0,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-pix-gray.svg'),
    height: 0,
    width: 0,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-pix-gray.svg'),
    height: 0,
    width: 0,
  },
};

export const Pix = {
  alt: 'Pague com Pix',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-pix.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-pix.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-pix.svg'),
    height: 40,
    width: 40,
  },
};

export const TwoCards = {
  alt: 'Pague com dois cartões',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-two-cards.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-two-cards.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-two-cards.svg'),
    height: 40,
    width: 40,
  },
};

export const Visa = {
  alt: 'Pague com Visa',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-visa.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-visa.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-visa.svg'),
    height: 40,
    width: 40,
  },
};

export const NuPay = {
  alt: 'Pague com NuPay',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-nupay.svg'),
    height: 40,
    width: 40,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-nupay.svg'),
    height: 40,
    width: 40,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-nupay.svg'),
    height: 40,
    width: 40,
  },
};
